import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { PaginationRequest } from '@shared/services';
import { RequestHelper } from '@shared/helpers/request.helper';

@Injectable({ providedIn: 'root' })
export class RoomEventApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/room-events`;
    }

    getRoomEventOptions(req: PaginationRequest, body?: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.post<any>(`${this.url}/options`, body || {}, { params: options });
    }

    createRoomEvent(roomEvent: any): Observable<any> {
        return this.httpClient.post<any>(this.url, roomEvent);
    }

    updateRoomEvent(roomEvent: any): Observable<any> {
        return this.httpClient.put<any>(this.url, roomEvent);
    }

    deleteRoomEvent(id: string): Observable<any> {
        return this.httpClient.delete<any>(this.url, { body: { id } });
    }
}
